// INSTISSP-1819 — SSP report calls against SRMS (via the PPA-minted token; see srms.js / srmsToken.js).
//
// These mirror the SSP report thunks currently in ppa.js, mapped to SRMS's routes. They are the endpoint
// plumbing; they are NOT yet swapped into state/thunks/report.js because two things still need decisions:
//   1. PAYLOAD SHAPE. SRMS's ReportTo != PPA's REPORT_V2 (relativeDate enum names, sendDate, a single unified
//      `filters` array, reportFormat, is_pp_report). The builder's request and SRMS's response must be mapped.
//      GEO alpha-2 and DEVICE MOBILE/DESKTOP are absorbed by SRMS's PP adapter (INSTISSP-1809), so those pass
//      through; the rest of the field mapping is the open work.
//   2. SSP + FAM MERGE (dev-tickets #13). The list shown to the user is SSP (SRMS) + FAM (PPA) de-duplicated by
//      uuid; only the SSP calls move here, FAM stays on ppa.js.
// Also: url.srms is a placeholder until the portal->SRMS network path is set (dev-tickets #14).
import srms from './srms';

// Server-scoped by the token (INSTISSP-1809): SRMS returns only this account's portal reports, so no account
// param is sent. Replaces ppa.getAllReportsByAccount(accountUUID).
export const getReports = ({ page = 1, limit = 100, sortBy = 'name', direction = 'DESC', searchTerm } = {}) =>
    srms.get('/reports', { params: { page, limit, sortBy, direction, ...(searchTerm ? { searchTerm } : {}) } });

// GET (not POST): SRMS reads a single report by uuid. Replaces ppa.getReport.
export const getReport = reportUUID => srms.get(`/reports/${reportUUID}`);

export const createReport = report => srms.post('/reports', report);

export const updateReport = report => srms.put(`/reports/${report.reportUUID}`, report);

export const deleteReport = reportUUID => srms.delete(`/reports/${reportUUID}`);

// Queued generation (INSTISSP-1813): submit a job, poll it, then fetch its file. Replaces ppa.downloadReport.
export const createReportJob = report => srms.post('/reports/jobs', report);

export const getReportJob = jobId => srms.get(`/reports/jobs/${jobId}`);

export const getReportJobFile = jobId =>
    srms.get(`/reports/jobs/${jobId}/file`, { responseType: 'blob' });

// Preview table (first 50 rows + totals, in RMS's preview shape). Replaces ppa.getPreviewReport.
export const previewReport = report => srms.post('/reports/preview/pp', report);
